export const audio1 = "1I793aOirrkzdZ-A0B_u1R35b3jfW39fv";

export const intro1 = "Welcome to Audio Dict! One of the fastest ways to passively increase your vocabulary and listening comprehension. The goal is to take you from not understanding a single word to being able to understand native speakers and have a conversation with them. Each lesson will contain an audio file and a transcript. Your job is to study the transcript and then listen to the audio file as many times as you need. Feel free to download the audio and listen to it offline while cooking, riding the bus, exercising, etc. Once the audio becomes too easy to understand, move on to the next lesson!";

const nouns = ['woman', 'man', 'girl', 'boy'];
const adjectives = ['happy', 'sad', 'hardworking', 'lazy'];

export const vocab1 = {
    happy: ['kāixīn', '开心'],
    sad: ['shāngxīn', '傷心'],
    hardworking: ['qínláo', '勤劳'],
    lazy: ['lǎnduò', '懒惰'],
    of: ['de', '的'],
    woman: ['nǚrén', '女人'],
    man: ['nánrén', '男人'],
    girl: ['nǚhái', '女孩'],
    boy: ['nánhái', '男孩'],
    '.': ['.', '。'],
};

export const lesson1 = [
    ...adjectives.map(adj => (nouns.map(noun => (
        {
            literal: [adj, 'of', noun, '.'],
            translated: [adj, noun, '.']
        }
    ))
    )).flat(),
    ...nouns.map(noun => (adjectives.map(adj => (
        {
            literal: [adj, 'of', noun, '.'],
            translated: [adj, noun, '.']
        }
    ))
    )).flat()
];